import { api } from "./api";

export const AdminDashboardApi = async (addUrl = ``) => {
  return await api.get(`/admin/dashboard?${addUrl}`);
};
export const AdminStudentReport = async (addUrl = ``) => {
  return await api.get(`/admin/student/report?${addUrl}`);
};
export const AdminBranchList = async (addUrl = ``) => {
  return await api.get(`/admin/branch/list?${addUrl}`);
};
export const AdminFinanceReport = async (addUrl = ``) => {
  return await api.get(`/admin/finance/report?${addUrl}`);
};
export const AdminBranchStatusUpdate = async (data) => {
  return await api.post(`/admin/branch/status/update`, data);
};
export const branchAdd = async (data) => {
  return await api.post("admin/branch/add", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const branchUpdate = async (data) => {
  return await api.post("admin/branch/update", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const superAdminAdd = (data) => {
  return api.post("admin/super/admin/add", data);
};
